import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'

// Actions
import { saveData } from './actions'

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dsc1: 'Loading...',
      dsc2: 'Loading...',
      dsc3: 'Loading...',
      dsc4: 'Loading...',
      dsc5: 'Loading...',
      clr1: 'Loading...',
      clr2: 'Loading...',
      clr3: 'Loading...',
      oar_high: 10,
      oar_low: 7,
      age_high: 54,
      age_low: 35,
      herprefage: 0,
      education: -1,
      income: -1,
      pref_fans: 0,
      popLoaded: false,
      saved_search_id: '',
      count: 'Loading...',
      name: '',
      pref_fans: 0
    }
  }

  getDSCPopulation() {
    let currentComponent = this

    var data1 = 0
    var data2 = 0
    var data3 = 0
    var data4 = 0
    var data5 = 0
    var data6 = 0
    var data7 = 0
    var data8 = 0

    let url1 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/1/dsclow/1/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url2 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/2/dsclow/2/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url3 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/3/dsclow/3/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url4 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/4/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url5 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/5/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/4/clrlow/1/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url6 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/1/clrlow/1/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url7 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/2/clrlow/2/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url8 =
      'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/3/clrlow/3/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number

    /*
    alert(url1)
    alert(url2)
    alert(url3)
    alert(url4)
    alert(url5)
    alert(url6)
    alert(url7)
    alert(url8)
*/
    // DSC Code 1
    axios.get(url1).then(function(response) {
      let s = JSON.stringify(response.data[0]).toString()
      data1 = s.split('SearchCount":')[1].replace('}', '')
      //data1 = response.data[0]["SearchCount"]

      // DSC Code 2
      axios.get(url2).then(function(response) {
        let s = JSON.stringify(response.data[0]).toString()
        data2 = s.split('SearchCount":')[1].replace('}', '')
        //data2 = response.data[0]["SearchCount"]

        // DSC Code 3
        axios.get(url3).then(function(response) {
          let s = JSON.stringify(response.data[0]).toString()
          data3 = s.split('SearchCount":')[1].replace('}', '')
          //data3 = response.data[0]["SearchCount"]

          // DSC Code 4
          axios.get(url4).then(function(response) {
            let s = JSON.stringify(response.data[0]).toString()
            data4 = s.split('SearchCount":')[1].replace('}', '')
            //data4 = response.data[0]["SearchCount"]

            // DSC Code 5
            axios.get(url5).then(function(response) {
              let s = JSON.stringify(response.data[0]).toString()
              data5 = s.split('SearchCount":')[1].replace('}', '')
              //data5 = response.data[0]["SearchCount"]

              // CLR Code 1
              axios.get(url6).then(function(response) {
                let s = JSON.stringify(response.data[0]).toString()
                data6 = s.split('SearchCount":')[1].replace('}', '')
                //data6 = response.data[0]["SearchCount"]

                // CLR Code 2
                axios.get(url7).then(function(response) {
                  let s = JSON.stringify(response.data[0]).toString()
                  data7 = s.split('SearchCount":')[1].replace('}', '')
                  //data7 = response.data[0]["SearchCount"]

                  // CLR Code 3
                  axios.get(url8).then(function(response) {
                    let s = JSON.stringify(response.data[0]).toString()
                    data8 = s.split('SearchCount":')[1].replace('}', '')
                    //data8 = response.data[0]["SearchCount"]

                    currentComponent.setState({
                      dsc1: data1 + ' Candidates.',
                      dsc2: data2 + ' Candidates.',
                      dsc3: data3 + ' Candidates.',
                      dsc4: data4 + ' Candidates.',
                      dsc5: data5 + ' Candidates.',
                      clr1: data6 + ' Candidates.',
                      clr2: data7 + ' Candidates.',
                      clr3: data8 + ' Candidates.',
                      popLoaded: true
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  }

  componentDidMount() {
    let com = this
    setTimeout(() => {
      com.getPopulationCountData()
    }, 500)
  }

  getPopulationCountData() {
    let currentComponent = this

    axios
      .get(
        `https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/54/agelow/35/oarhigh/10/oarlow/7/herprefage/0/herprefans/0/clrhigh/4/clrlow/1/education/-1/income/-1/cust/${
          this.props.customer_number
        }`
      )
      .then(function(response) {
        if (response.data[0].SearchCount) {
          currentComponent.setState(
            {
              count: response.data[0]['SearchCount']
            },
            function() {
              currentComponent.getDSCPopulation()
            }
          )
        } else {
          currentComponent.getPopulationCountData()
        }
      })
  }

  onSelectDatingCode(dsc) {
    if (this.state.popLoaded) {
      this.props.saveData(
        dsc,
        4,
        'dsc',
        this.state.oar_low,
        this.state.oar_high,
        this.state.age_low,
        this.state.age_high,
        this.state.herprefage,
        this.state.income,
        this.state.education,
        this.state.pref_fans
      )

      if (dsc == 5) {
        this.props.changeRoute(
          '/console/search/all_candidates/results?l=show_omit'
        )
      } else {
        this.props.changeRoute('/console/search/all_candidates/results')
      }
    } else {
      alert('Please wait for the population counts to load.')
    }
  }

  onSelectColor(clr) {
    if (this.state.popLoaded) {
      this.props.saveData(
        4,
        clr,
        'clr',
        this.state.oar_low,
        this.state.oar_high,
        this.state.age_low,
        this.state.age_high,
        this.state.herprefage,
        this.state.income,
        this.state.education,
        this.state.pref_fans
      )
      this.props.changeRoute('/console/search/all_candidates/results')
    } else {
      alert('Please wait for the population counts to load.')
    }
  }

  onSelectNoFilter() {
    this.props.saveData(
      5,
      4,
      'none',
      this.state.oar_low,
      this.state.oar_high,
      this.state.age_low,
      this.state.age_high,
      this.state.herprefage,
      this.state.income,
      this.state.education,
      this.state.pref_fans
    )
    this.props.changeRoute('/console/search/all_candidates/results')
  }

  render() {
    const { classes, theme, location } = this.props
    const { count } = this.state

    return (
      <div className={classes.content}>
        <div className={classes.buttonNoFilter}>
          <Typography type="body2">Active Population Count: {count}</Typography>
        </div>
        <div className={classes.buttonNoFilter}>
          <Typography type="body2">All Candidates</Typography>
          <Typography>Click Below to Add Sub-Filter:</Typography>
        </div>
        <br />
        <br />
        <Card className={classes.card}>
          <CardContent>
            <Typography>By Color Notification:</Typography>
            <br />
            <Button
              className={classes.buttonYellow}
              raised
              onClick={() => this.onSelectColor(3)}
            >
              New Candidates Only
            </Button>
            <Typography>{this.state.clr3}</Typography>
            <br />
            <Button
              className={classes.button}
              raised
              onClick={() => this.onSelectColor(1)}
            >
              Returning Candidates Only
            </Button>
            <Typography>{this.state.clr1}</Typography>
            <br />
            <Button
              className={classes.buttonLightGreen}
              raised
              onClick={() => this.onSelectColor(2)}
            >
              Needs Response
            </Button>
            <Typography>{this.state.clr2}</Typography>
            <br />
          </CardContent>
        </Card>
        <div className={classes.space} />
        <Card className={classes.card}>
          <CardContent>
            <Typography>By Priority Code:</Typography>
            <br />
            <Button
              className={classes.buttonDating}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(1)}
            >
              Dating
            </Button>
            <Typography>{this.state.dsc1}</Typography>
            <br />
            <Button
              className={classes.buttonPursuing}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(2)}
            >
              Actively Pursuing
            </Button>
            <Typography>{this.state.dsc2}</Typography>
            <br />
            <Button
              className={classes.buttonWaiting}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(3)}
            >
              Waiting to Hear
            </Button>
            <Typography>{this.state.dsc3}</Typography>
            <br />
            <Button
              className={classes.buttonGaveUp}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(4)}
            >
              Gave Up For Now
            </Button>
            <Typography>{this.state.dsc4}</Typography>
            <br />
            <Button
              className={classes.buttonBlack}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(5)}
            >
              Show Omitted
            </Button>
            <Typography>{this.state.dsc5}</Typography>
            <br />
          </CardContent>
        </Card>
        <div className={classes.space} />
        <div className={classes.buttonNoFilter}>
          <Button
            className={classes.buttonNoFilter}
            align="center"
            color="primary"
            onClick={() => this.onSelectNoFilter()}
          >
            No Sub Filter
          </Button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    filter_id: state.saved.filter_id
  }
}

function matchDispatchToProps(dispatch) {
  return {
    saveData: bindActionCreators(saveData, dispatch),
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/AllCandidates/scenes/Start/index.js